<template>
  <div class="admin-orders">
    <header-title title="Cierres de caja (Z)"></header-title>

    <div class="page-title">
      <v-container class="pl-0 pr-0">
        <v-row justify="center" style="margin-bottom: 15px;">
          <v-col cols="12" sm="6" md="3" class="py-0 py-sm-1">
            <span class="cash_start mx-sm-3">
              Último inicio de caja a las:
              <div>
                <span class="day-format">
                  {{ dayFormatLL(zClosuresLast.opened_on) }}
                </span>
                {{ formatTime(zClosuresLast.opened_on) }}
              </div>
            </span>
          </v-col>
          <v-col cols="12" sm="6" md="3" class="py-0 py-sm-1">
            <v-btn
              :style="`border: 3px solid ${colorsGeneralPrimary}`"
              :color="colorsGeneralPrimary"
              outlined
              text
              class="admin-excel-download-btn mx-3"
              @click="openDialog"
            >
              CERRAR CAJA (Z)
            </v-btn>
          </v-col>
        </v-row>

        <v-row justify="center">
          <v-col cols="12" sm="6" md="3" class="py-0 py-sm-1">
            <date-picker-range
              @updateDates="onChangeDate"
              :substract1month="true"
            ></date-picker-range>
          </v-col>
          <v-col cols="12" sm="6" md="3" class="py-0 py-sm-1">
            <v-btn
              :style="`border: 3px solid ${colorsGeneralPrimary}`"
              :color="colorsGeneralPrimary"
              outlined
              text
              class="admin-excel-download-btn mx-3"
              @click="$refs.zClosureTableRef.exportToExcel(excelName)"
            >
              Exportar a Excel
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <h2 class="page-title">TOTAL: {{ formatPrice(totalAmount) }}</h2>

    <ZboxClosuresTable
      :z_closures="zclosures"
      ref="zClosureTableRef"
    ></ZboxClosuresTable>
    <ZboxClosureDialog
      @updateZclosures="onChangeDate(rangeOfDates)"
      :zClosuresLast="zClosuresLast"
      :hasRoleOwner="hasRoleOwner"
      ref="zBoxClosureDialog"
    ></ZboxClosureDialog>
  </div>
</template>

<script>
import moment from "moment";
import ZboxClosuresTable from "@/components/admin/z-box-closures/ZboxClosuresTable";
import ZboxClosureDialog from "@/components/admin/z-box-closures/ZboxClosureDialog";
import HeaderTitle from "@/components/admin/common/HeaderTitle.vue";
import { zClosuresCollection } from "@/collections/zClousures";
import DatePickerRange from "@/components/common/DatePickerRange";

const INITIAL_DATE_START = moment()
  .startOf("day")
  .subtract(1, "month")
  .toDate();

const INITIAL_DATE_END = moment()
  .endOf("day")
  .toDate();

export default {
  name: "ZBoxClosures",
  components: {
    ZboxClosuresTable,
    ZboxClosureDialog,
    HeaderTitle,
    DatePickerRange
  },
  data() {
    return {
      dialog: false,
      locale: {
        id: "es",
        firstDayOfWeek: 2,
        masks: {
          input: "YYYY-MM-DD 00:00:00"
        }
      },
      popover: {
        visibility: "click"
      },
      rangeOfDates: {
        start: INITIAL_DATE_START,
        end: INITIAL_DATE_END
      },
      zClosuresLastDoc: []
    };
  },
  firestore() {
    return {
      zClosuresLastDoc: zClosuresCollection
        .where("closed_on", "==", null)
        .orderBy("opened_on", "desc")
        .limit(1)
    };
  },
  computed: {
    totalAmount() {
      let total = 0;
      this.zclosures.forEach(row => {
        total +=
          Number(row.total_invoiced_on_credit_card) +
          Number(row.total_invoiced_in_cash) +
          Number(row.total_invoiced_in_datafono) +
          Number(row.total_invoiced_in_google_pay) +
          Number(row.total_invoiced_in_apple_pay) +
          Number(row.total_invoiced_in_bizum);
      });

      return total;
    },
    hasRoleOwner() {
      return this.$store.getters.hasRoleOwner;
    },
    excelName() {
      return `cierre_de_caja(${this.dayFormat2(
        this.rangeOfDates.start
      )}-${this.dayFormat2(this.rangeOfDates.start)}).xls`;
    },
    zClosuresLast() {
      let zClosuresHistory = [...this.zClosuresLastDoc];
      let lastElement = zClosuresHistory[0];

      return lastElement ? lastElement : "";
    },
    zclosures() {
      return [...this.$store.state.zClosuresHistory];
    }
  },
  methods: {
    async onChangeDate(dates) {
      let _rangeOfDates = {
        start: moment()
          .startOf("day")
          .format("YYYY-MM-DD"),
        end: moment()
          .endOf("day")
          .format("YYYY-MM-DD")
      };

      if (this.hasRoleOwner) {
        let date1;
        let date2;

        if (dates.length === 1 || dates[0] === dates[1]) {
          date1 = moment(dates[0])
            .startOf("day")
            .toDate();
          date2 = moment(dates[0])
            .endOf("day")
            .toDate();
        }

        if (dates.length === 2) {
          date1 = moment(dates[0])
            .startOf("day")
            .toDate();
          date2 = moment(dates[1])
            .endOf("day")
            .toDate();
        }

        _rangeOfDates = {
          start: date1,
          end: date2
        };
      }

      this.rangeOfDates = _rangeOfDates;

      await this.$store.dispatch(
        "zClosuresHistoryByRangeOfDate",
        _rangeOfDates
      );
    },
    openDialog() {
      this.$refs.zBoxClosureDialog.open();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.select-product-type {
  font-size: 16px;
  padding: 6px;
  border-radius: 3px;
  background: #fff;
  margin-left: 10px;
  border: 1px solid #cbd5e0;
}

.filters {
  width: 70%;
  margin: 0 auto;
}

@media (max-width: 991px) {
  .filters {
    width: 100%;
  }
}

::v-deep {
  .vc-popover-content-wrapper {
    @media screen and (max-width: 471px) {
      width: 80%;
      overflow: hidden;
    }
  }

  .vc-popover-content {
    @media screen and (max-width: 471px) {
      width: 95%;
      overflow: auto;
    }
  }
}
</style>
